import { Point } from '@printu/geom';
import { generateSimpleArrowShape } from 'app/core/graphics/Arrow';
import { getMarkerStyles } from 'app/core/markers/models';
import { compileFancyArrowPath, compileShapePath, } from 'app/core/rendering/compiler';
import { fillMarkerRenderer, strokeMarkerRenderer } from './painters';
export const renderArrowMarker = (marker, opts, ctx) => {
    const arrow = marker;
    const startPoint = new Point(arrow.x, arrow.y);
    const endPoint = new Point(arrow.x + arrow.endX, arrow.y + arrow.endY);
    const width = 1.5 * arrow.size;
    switch (arrow.type) {
        case 'simple':
            {
                const lineShape = generateSimpleArrowShape(startPoint, endPoint, width);
                if (lineShape) {
                    const painter = compileShapePath(lineShape);
                    ctx.save();
                    ctx.lineJoin = 'round';
                    ctx.lineCap = 'round';
                    strokeMarkerRenderer(ctx, getMarkerStyles(marker), painter, opts);
                    ctx.restore();
                }
            }
            break;
        case 'fancy':
            {
                const painter = compileFancyArrowPath(startPoint, endPoint, width);
                const style = {
                    fillColor: marker.color,
                    strokeColor: '#FFFFFF',
                    strokeWidth: marker.size,
                };
                ctx.save();
                ctx.lineJoin = 'round';
                ctx.lineCap = 'round';
                fillMarkerRenderer(ctx, style, painter, opts);
                ctx.restore();
            }
            break;
        default:
            break;
    }
};
